import { render, staticRenderFns } from "./IconCloseLg.vue?vue&type=template&id=c164ff86&"
import script from "./IconCloseLg.vue?vue&type=script&lang=js&"
export * from "./IconCloseLg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c164ff86')) {
      api.createRecord('c164ff86', component.options)
    } else {
      api.reload('c164ff86', component.options)
    }
    module.hot.accept("./IconCloseLg.vue?vue&type=template&id=c164ff86&", function () {
      api.rerender('c164ff86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconCloseLg.vue"
export default component.exports